<template>
  <div class="table__cell">
    <div>{{ item.name }}</div>
    <div class="table__cell-actions">
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <ui-button
            color="primary"
            outlined
            icon="icon-download"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t("message.reviewBooster.formList.formLink") }}
            <v-icon right>mdi-chevron-down</v-icon>
          </ui-button>
        </template>
        <v-list>
          <v-list-item
            v-for="format in exportFormats"
            :key="format.value"
            @click="exportLinks(format.value)"
          >
            <v-list-item-title>{{ format.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <ui-button
        color="primary"
        icon="icon-download"
        @click="$emit('export-stats', item.key)"
      >
        {{ $t("message.common.stats") }}
      </ui-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewBoosterFormDatagridRow",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      exportFormats: [
        { text: "CSV", value: "csv" },
        { text: "XLSX", value: "xlsx" }
      ]
    };
  },
  methods: {
    exportLinks(file_format) {
      this.$emit("export-links", {
        key: this.item.key,
        file_format
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table__cell {
  padding: $spacing * 2 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-left: $spacing * 2;

  &:before {
    content: "";
    display: block;
    width: 3px;
    height: 53px;
    background: $primary;
    position: absolute;
    left: 0;
  }

  &-actions {
    display: flex;
    gap: $spacing * 4;
  }
}
</style>
